// extracted by mini-css-extract-plugin
module.exports = {"card":"PriceTooLow_card__1TID0","buyWithCard":"PriceTooLow_buyWithCard__3L7ag","paragraph":"PriceTooLow_paragraph__1hZ4Z","switchNetwork":"PriceTooLow_switchNetwork__2mSF-"};